import React, { useState } from "react";
import { motion } from "framer-motion";
import BookDemoForm from "../../../../components/BookDemoForm/BookDemoForm";
import chatbotImage from "../../../../assets/images/DigitalBrain.png";

const NewHeroSection = () => {

      const [showFormModal, setShowFormModal] = useState(false);
    
      const handleFormToggle = () => {
        setShowFormModal(!showFormModal);
      };
  return (
    <section className="bg-white text-black font-sans py-16">
      {/* Hero Content */}
      <div className="text-center py-24 px-6 md:px-12 lg:px-24">
        <div className="max-w-5xl mx-auto">
          <motion.h1
            className="text-5xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-6"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Self-Hosted Custom GPT For Your
            Business!
          </motion.h1>
          <motion.p
            className="text-lg md:text-xl text-gray-700 leading-relaxed mb-8 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
           It’s very similar to ChatGPT, but with one big difference…
           Trained on your company Data, hosted privately and securely on your own system. You have full control over sensitive company data.
          </motion.p>

          {/* Call to Action */}
          <motion.button
            className="px-8 py-4 text-lg font-semibold bg-blue-600 text-white rounded-full shadow-xl 
            hover:bg-blue-700 transition-transform transform hover:scale-105"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleFormToggle}>
            Free Consultation
          </motion.button>

          <p className="text-sm text-gray-500 mt-4 max-w-md mx-auto">
          With our AI-powered assistant, everything stays secure, and you always have full control over your data. It’s like having a digital brain for your business, always ready to assist.
          </p>
        </div>
      </div>

      {/* Stats Section */}
      <div className="bg-black py-24">
        <div className="flex flex-col md:flex-row items-center justify-center text-white gap-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center px-6"
          >
            <p className="text-6xl font-bold">40,000+</p>
            <p className="text-lg underline">Hours of manual work</p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="max-w-2xl text-center px-6"
          >
            <p className="text-2xl md:text-3xl font-semibold">
              Have been replaced with AI and Automation for our clients
            </p>
          </motion.div>
        </div>
      </div>
      {showFormModal && <BookDemoForm onClose={handleFormToggle} />}
      <div className="flex justify-center mt-12 px-6">
        <img
          src={chatbotImage} // Change this to your image path
          alt="Custom GPT AI"
          className="max-w-full md:max-w-3xl rounded-lg shadow-lg"
        />
      </div>
      
    </section>
  );
};

export default NewHeroSection;
